import React from 'react';
import { TopchemieNavbar } from '../blocks/topchemie-navbar';

const Header: React.FC = () => {
  return (
    <TopchemieNavbar />
  );
};

export default Header;